import type { ChatMessage, AvailableResultTable } from "./types";
import { isSafeExportHref } from "./tableExport";
const cell = (text: string) =>
  text
    .replace(/\\/g, "\\\\")
    .replace(/\|/g, "\\|")
    .replace(/[\r\n]+/g, " ");
function tableText(table: AvailableResultTable) {
  const row = (values: string[]) => `| ${values.join(" | ")} |`;
  return [
    table.title,
    row(table.columns.map((column) => cell(column.label))),
    row(table.columns.map(() => "---")),
    ...table.preview_rows
      .slice(0, 25)
      .map((values) =>
        row(
          values.map((value) =>
            isSafeExportHref(value.href)
              ? `[${cell(value.text).replace(/\]/g, "\\]")}](${value.href})`
              : cell(value.text)
          )
        )
      ),
  ].join("\n");
}
export function answerCopyText(message: ChatMessage): string {
  const placed = new Set<string>();
  let text = (message.content || "").replace(
    /<!-- agentic-result-table:([\w-]+) -->[\s\S]*?<!-- \/agentic-result-table:\1 -->/g,
    (fallback, id: string) =>
      message.tables?.some((table) => table.id === id)
        ? `[[table:${id}]]`
        : fallback.replace(/<!--.*?-->/g, "")
  );
  text = text.replace(/\[\[table:([^\]\n]+)\]\]/g, (_, id: string) => {
    const table = message.tables?.find((item) => item.id === id);
    if (!table || placed.has(id)) return "";
    placed.add(id);
    return table.available
      ? tableText(table)
      : "This saved table is no longer available. Run the search again.";
  });
  for (const table of message.tables || []) {
    if (!placed.has(table.id)) {
      text += `\n\n${
        table.available
          ? tableText(table)
          : "This saved table is no longer available. Run the search again."
      }`;
    }
  }
  if (message.citations?.length) {
    text +=
      "\n\nReferences\n" +
      message.citations
        .map((c) =>
          isSafeExportHref(c.url || undefined)
            ? `- [${(c.name || c.product_number || c.id).replace(
                /\]/g,
                "\\]"
              )}](${c.url})`
            : `- ${c.name || c.product_number || c.id}`
        )
        .join("\n");
  }
  return text.trim();
}
